module.exports = __webpack_public_path__ + "img/arrow-expand-white.a2aa981c.svg";